import { render, staticRenderFns } from "./HeaderLogo.vue?vue&type=template&id=2a4b8695&scoped=true"
import script from "./HeaderLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderLogo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeaderLogo.vue?vue&type=style&index=0&id=2a4b8695&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2a4b8695",
  null
  
)

export default component.exports